export default "__VITE_ASSET__Cb2pB1IK__"